export function getTheme(state) {
  return state.theme.theme;
}

export function getRoutes(state) {
  return state.routes;
}

export function getLocale(state) {
  return state.locale.locale;
}
